import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algoritmia.png",
      alt: "Estratégias Algoritmia",
    },
    title: "Algoritmia - Investimentos automatizados",

    // String ou array de strings
    text: [
      "Estratégias automatizadas desenvolvidas com técnicas de otimização de algoritmos auxiliada por computação de alta performance, assinadas pelo estrategista Sérgio Moura.",
    ],
    testimonial: {
      text: "Proporcionamos ao investidor de varejo a vantagem estatística que ele precisa para obter sucesso no mercado financeiro",
      author: {
        name: "Sérgio R. S. Moura - Estrategista Chefe",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Portfólio Algoritmia",
    heading: "As nossas melhores estratégias à sua disposição",
    subtitle:
      "Um portfólio desenvolvido com as mais avançadas ferramentas de otimização assistida por computação de alta performance, ao alcance de alguns cliques.",
  },

  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora a extensão Algoritmia",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "Algoritmia",
    col1: [
      "Fundada em 2022, a Algoritmia desenvolve algoritmos para projetos de automação diversos, tendo se aprimorado no desenvolvimento de estratégias para day trading com robôs. Os algoritmos são desenvolvidos com técnicas de otimização assistida por computação de alta performance, sendo então submetidos a um exaustivo processo de validação e acompanhamento prospectivo, supervisionado pelo estrategista chefe Sérgio Moura. O objetivo da empresa é oferecer ao investidor de varejo estratégias capazes de proporcionar uma vantagem estatística consistente no mercado financeiro, convertendo-se em lucro através de operações de day trading com robôs.",
    ],
    // col2: [
    //   "Nossa missão é ajudar traders de todos os níveis a aproveitar as vantagens da automação no mercado financeiro.",
    // ],
  },

  stats: {
    title: "Opere o melhor da Algoritmia",
    subtitle:
      "Rigoroso sistema de seleção e qualidade para oferecer ao cliente o melhor do melhor",
    data: [
      {
        value: "+50mi",
        description: "Backtests",
      },
      {
        value: "350",
        description: "Robôs em testes prospectivos",
      },
      {
        value: "3",
        description: "Robôs para o cliente final",
      },
    ],
  },

  features: {
    title: "Por que utilizar os nossos robôs?",
    subtitle: "Veja quais as principais vantagens dos robôs Algoritmia.",
    data: [
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Todos os indicadores técnicos, alvos, stops e gestão de risco diário são ajustados pela nossa equipe de estrategistas. Você não precisa interferir em nada.",
      },
      {
        icon: iconsSet.cloud,
        title: "100% em nuvem",
        description:
          "Toda a operação do robô é hospedada em servidores remotos. Não há necessidade de deixar seu computador ou celular conectado para o robô operar.",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem fator emocional",
        description:
          "O psicológico é o principal detrator de performance do trader. Um robô não sente emoções e fará exatamente o que foi programado para fazer.",
      },
      {
        icon: iconsSet.growth,
        title: "Liberte a sua mente",
        description:
          "Desenvolver estratégias e um operacional requer tempo, dedicação e não há garantias de sucesso. Deixe que a nossa equipe de estrategistas quebre a cabeça por você.",
      },
      {
        icon: iconsSet.clock,
        title: "Mais tempo para você",
        description:
          "Deixe um robô programado por uma equipe de profissionais ganhando dinheiro para você e curta o tempo com o que realmente importa na sua vida.",
      },
      {
        icon: iconsSet.calendar,
        title: "7 dias gratuitos para testar",
        description:
          "Não ficou satisfeito ao fim de 7 dias? Receba o seu dinheiro de volta.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "Quem é mãe sabe da dificuldade em conciliar família e trabalho. Com três filhos pequenos, preciso trabalhar muito para equilibrar as contas. Obter uma renda extra através dos robôs foi um alívio para o nosso orçamento doméstico e me permitiu passar mais tempo com a minha família.",
      author: "Andrea Araújo",
      job: "Advogada",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Esqueça as promessas de ganhos irreais que te vendem no mercado. A Algoritmia oferece um trading system consistente, realista e transparente, para alavancar os investimentos de forma sustentável no longo prazo.",
      author: "Danielle Virgínio",
      job: "Advogada",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Algoritmia",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
